<ng-container>
  <mat-toolbar color="accent" id="headerPrint">
    <div class="tiTex">{{ 'pages.auswertungen.title' | translate}}</div>

  </mat-toolbar>

  <div class="add-button-container">
    <button mat-mini-fab
            matTooltip="Neue Zeit erfassen"
            matTooltipShowDelay='2000'
            color="primary"
            aria-label="Add a address"
            class="pluscolor"
            (click)=openFilter()>
      <mat-icon>add</mat-icon>
    </button>

  </div>
<!--  <button  class="noPrint" (click)="print()">D R U C K E N</button> -->
  <div  class="page-content">
    <app-auswertungen-table

      id="printMe"
    >
    </app-auswertungen-table>
  </div>
</ng-container>
